import { forwardRef, Ref, useState } from "react";

import { labelCss, rootCss } from "./withHoverStateLabel.style";

interface WithHoverStateLabelProps {
  forwardedRef?: Ref<HTMLButtonElement> | null;
  hoverLabel?: string;
}

function withHoverStateLabel<T extends WithHoverStateLabelProps>(
  WrappedComponent: React.ComponentType<T>,
) {
  const WithHoverStateLabel = (props: T & WithHoverStateLabelProps) => {
    const [isHoveringElement, setIsHoveringElement] = useState(false);
    const { forwardedRef, hoverLabel } = props;

    const eventListenerProps = {
      onBlur: () => {
        setIsHoveringElement(false);
      },
      onFocus: () => {
        setIsHoveringElement(true);
      },
      onMouseEnter: () => {
        setIsHoveringElement(true);
      },
      onMouseLeave: () => {
        setIsHoveringElement(false);
      },
    };

    return !hoverLabel ? (
      <WrappedComponent {...props} ref={forwardedRef} />
    ) : (
      <div
        {...eventListenerProps}
        css={rootCss}
        data-testid="hoc-hover-label-wrapper"
      >
        <WrappedComponent
          {...props}
          hoverLabel={hoverLabel}
          ref={forwardedRef}
        />
        <span css={labelCss(isHoveringElement)} data-testid="hoc-hover-label">
          {hoverLabel}
        </span>
      </div>
    );
  };

  return forwardRef<HTMLButtonElement, T & WithHoverStateLabelProps>(
    (props, ref) => <WithHoverStateLabel {...props} forwardedRef={ref} />,
  );
}

export default withHoverStateLabel;
